import styled from "styled-components";

export const Title = styled.div`
  font: normal normal 600 30px/27px Open Sans;
  text-align: center;
  margin-top: 60px;
  margin-bottom: 40px;
  color: ${({ theme }) => {
    return theme.colors.title;
  }};
`;

export const Warning = styled.div`
  text-align: center;
  font: normal normal 600 18px/24px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.warning;
  }};
`;

export const Success = styled.div`
  text-align: center;
  font: normal normal 600 18px/24px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.green;
  }};
`;

export const ErrorText = styled.div`
  text-align: center;
  font: normal normal 600 18px/24px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.red;
  }};
`;
export const HelperText = styled.div`
  margin-top: 10px;
  text-align: center;
  font: normal normal normal 16px/22px Open Sans;
  color: ${({ theme }) => {
    return theme.colors.lightgrey;
  }};
`;

export const ButtonContainer = styled.div`
  margin-top: 37px;
  margin-left: 146px;
  margin-right: 146px;
`;
